<template>
  <div>
    <v-card class="rounded-lg" color="#41916b" elevation="0">
      <v-tabs fixed-tabs background-color="#41916b" dark>
        <v-tabs-slider color="#FFFFFF"></v-tabs-slider>
        <v-tab>{{ $t('titles.orgons_captureds') }}- {{ donorData.name }}</v-tab>
        <v-tab-item>
          <v-container>
            <template>
              <v-data-table
                :headers="headers"
                :items="resource"
                :items-per-page="10"
                :footer-props="{ 'items-per-page-text': 'Orgãos Captados por Página' }"
                class="elevation-1"
              >
                <template v-slot:[`item.orgon_captured_status.description`]="{ item }">
                  <div class="d-flex align-center justify-center">
                    <span>{{ item.orgon_captured_status.description }}</span>
 
                    <v-tooltip bottom color="#3fa118">
                      <template v-slot:activator="{ on, attrs }"> 
                        <v-icon
                        data-cy="visualizar-orgao"
                          v-bind="attrs"
                          v-on="on"
                          :color="
                            item.orgon_captured_status.description != 'Captado'
                              ? '#3fa118'
                              : 'grey'
                          "
                          class="ml-2 cursor-pointer"
                          size="24"
                          :disabled="
                            item.orgon_captured_status.description == 'Captado'
                          "
                          @click="openDialog(item, 'view')"
                        >
                          mdi-eye
                        </v-icon>
                      </template>
                      <span style="color:white">{{ $t('buttons.view') }}</span>
                    </v-tooltip>
 
                    <v-tooltip bottom color="primary">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                         data-cy="editar-orgao"
                          v-bind="attrs"
                          v-on="on"
                          :color="
                            item.orgon_captured_status.description != 'Captado'
                              ? 'primary'
                              : 'grey'
                          "
                          class="cursor-pointer"
                          size="24"
                          :disabled="
                            item.orgon_captured_status.description == 'Captado'
                          "
                          @click="openDialog(item, 'edit')"
                        >
                          mdi-pencil
                        </v-icon>
                      </template>
                      <span style="color:white">{{$t('buttons.edit')}}</span>
                    </v-tooltip>
                  </div>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-menu left :offset-x="true">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                       data-cy="menu-acoes-orgao"
                        size="20"
                        class="icon"
                        :color="
                          item.orgon_captured_status.description == 'Captado'
                            ? '#3fa118'
                            : 'grey'
                        "
                        align-item="center"
                        v-on="on"
                        v-bind="attrs"
                        @click="$router.push({ query: { item: item } })"
                        >mdi-cog
                      </v-icon>
                    </template>
                    <v-list dense class="rounded-lg">
                      <div class="text-center py-2 font-bold">
                        <span>{{ $t('titles.menu_actions') }}</span>
                      </div>
                      <v-list-item
                      data-cy="editar-status-orgao"
                        v-for="(menuItem, index) in menuActions"
                        :key="index"
                        @click="setItem(item, menuItem)"
                      >
                        <v-icon class="mr-2" :color="menuItem.color">{{
                          menuItem.icon
                        }}</v-icon>
                        <span style="color: black">{{ menuItem.title }}</span>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
              </v-data-table>
              <div class="action-buttons"> 
                <v-btn
                  class="rounded-lg action-btn"
                  color="#41916b"
                  dark
                  :loading="loading"
                  @click="checkOrgons()"
                  v-if="activeConcludeButton"
                >
                  {{ $t('buttons.conclude') }}
                </v-btn> 
                <BackToGridBtn />
              </div>
            </template>
          </v-container>
        </v-tab-item>
      </v-tabs>
    </v-card>

    <v-dialog v-model="orgonWarningDialog" max-width="400">
      <v-card class="pa-4 rounded-lg">
        <v-card-title class="text-h6">{{ $t('titles.pending_orgons') }}</v-card-title>
        <v-card-text>
          <div v-for="(orgon, index) in pendingOrgons" :key="index">
            - {{ orgon.orgon.name }}
          </div>
          <div class="mt-2">{{ $t('messages.pending_items') }}</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#41916b" text @click="orgonWarningDialog = false"
            >{{ $t('buttons.close') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog"
      transition="dialog-bottom-transition"
      max-width="600"
      persistent
    >
      <v-card class="rounded-lg">
        <OrgaosCaptadosForm
          @closeDialog="dialog = false"
          @loadTable="getOrgonsCaptureds()"
        />
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "@/axios";
import OrgaosCaptadosForm from "./OrgaosCaptadosForm.vue";
import { mapGetters, mapActions } from "vuex";
import BackToGridBtn from "@/components/widgets/BackToGridBtn";
export default {
  data() {
    return {
      headers: [
        { text: "Orgão", align: "center", value: "orgon.name" },
        {text: "Status", align: "center", value: "orgon_captured_status.description",
        },
        { text: "Ações", value: "actions", align: "center", sortable: false },
      ],
      statusOrgonsList: [],
      menuActions: [],
      resource: [],
      dialog: false,
      orgonWarningDialog: false,
      pendingOrgons: [],
      loading: false,
    };
  },

  created() {
    this.getOrgonsStatus();
    this.getOrgonsCaptureds();
  }, 

  computed: {
    ...mapGetters({
      donorData: "getPatientData",
      captationData: "getCaptationData",
    }),

    activeConcludeButton() {
      return [
        "doacao-efetivada",
      ].includes(this.resource[0].captation.donor.donor_status.slug);
    },

    getMenuOrgonsItems() {
      return this.statusOrgonsList.map((status) => ({
        title: status.description,
        icon: "mdi-checkbox-blank-circle",
        color: "blue",
        disabled: false,
      }));
    }, 
  },

  methods: {
    ...mapActions(["changeOrgonData", "changeSnackBarData"]),

    getOrgonsStatus() {
      axios
        .get(`/availabillity_status/list_availabillity_status`)
        .then((response) => {
          this.statusOrgonsList = response.data.data
            ? response.data.data
            : response.data;

          let changeName = {
            DESCARTADO: "DESCARTAR",
            DISPONIBILIZADO: "DISPONIBILIZAR",
            TRANSPLANTADO: "TRANSPLANTAR", 
          }; 

          this.menuActions = this.statusOrgonsList.map((status) => ({
            id: status.id, 
            title: changeName[status.description] || status.description,
            icon: this.getIcon(status.description),
            color: this.getColor(status.description),
          }));
        });
    },

    getOrgonsCaptureds() { 
      axios
        .get(`/orgons_captured/${this.donorData.id}`, {
          params: {
            status: "",
          },
        })
        .then((response) => {
          this.resource = response.data.data; 
        });
    },

    getIcon(description) {
      switch (description) {
        case "DESCARTADO":
          return "mdi-delete-empty";
        case "DISPONIBILIZADO":
          return "mdi-hand-heart";
        case "TRANSPLANTADO":
          return "mdi-signal-variant";
        default:
          return "mdi-help-circle";
      }
    },

    getColor(description) {
      switch (description) {
        case "DESCARTADO":
          return "red";
        case "DISPONIBILIZADO":
          return "green";
        case "TRANSPLANTADO":
          return "#41916b";
        default:
          return "grey";
      }
    },

    setItem(item, menuItem) { 
      this.dialog = true;
      const slug = this.setSlugAction(menuItem.title);

        let data = {
          orgon: item.orgon,
          orgon_captured_id: item.id,
          menuItem: {
            ...menuItem,
            slug
          }
        };

      this.changeOrgonData(data);
    },

    openDialog(item, type) {
      const action = {
        view: {
          title: "VISUALIZAR",
          icon: "mdi-eye",
          color: "#41916b",
          action: "view",
        },
        edit: {
          title: "EDITAR STATUS",
          icon: "mdi-pencil",
          color: "primary",
          action: "edit",
        },
      };

      const selected = action[type]; 
      this.dialog = true;

      const availability = item.availabillitys[0]; 
      const data = {
        orgon: item.orgon,
        view: availability,
        orgon_captured_id: item.id,
        menuItem: {
          ...selected,
          id: availability.availabillity_status_id,
          slug: this.setSlugAction(
            availability.availabillity_status.description
          ),
        },
      }; 

      this.changeOrgonData(data);
    },

    checkOrgons() { 
      const id = this.donorData.captation_id ? this.donorData.captation_id : this.captationData
      const pending = (this.resource || []).filter(
        (orgon) => orgon.orgon_captured_status.description === "Captado"
      );

      if (pending.length > 0) {
        this.pendingOrgons = pending;
        this.orgonWarningDialog = true;
      } else {
        this.$router.push("/pacientes");

        this.loading = true;
        let data = {
          captation_id: id,
        };

        axios
          .post(`/availability/conclude`, data)
          .then((response) => {
            this.changeSnackBarData({
              status: true,
              type: "success",
              titleMessage: response.data.message,
              bodyMessage: "",
              cardColor: "#41916b",
              titleIcon: "mdi-checkbox-marked-circle",
            });

            setTimeout(() => {
              this.loading = false;
              this.closeSnackBar();
              this.$router.push("/pacientes");
            }, 3000);
          })
          .catch((err) => {
            this.loading = false;
            this.changeSnackBarData({
              status: true,
              type: "erro",
              titleMessage: err.error,
              bodyMessage: err.details,
              cardColor: "red",
              titleIcon: "mdi-close-circle",
            });

            setTimeout(() => {
              this.closeSnackBar();
            }, 5000);
          });
      }
    },

    setSlugAction(description) {
      switch (description) {
        case "CAPTADO":
          return "CAPTADO";

        case "DISPONIBILIZADO":
        case "DISPONIBILIZAR":
          return "DISPONIBILIZACAO";

        case "DESCARTADO":
        case "DESCARTAR":
          return "DESCARTE";

        case "TRANSPLANTADO":
        case "TRANSPLANTAR":
          return "TRANSPLANTE";

        default:
          return "";
      }
    },

    closeSnackBar() {
      this.changeSnackBarData({
        status: false,
        type: "",
        titleMessage: "",
        bodyMessage: "",
        cardColor: "",
        titleIcon: "",
      });
    },
  },

  components: {
    OrgaosCaptadosForm,
    BackToGridBtn
  },
};
</script>
<style scoped>
.action-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
}

.action-btn {
  margin: 12px 4px;
}

@media (max-width: 768px) {
  .action-buttons {
    margin-top: 8px;
    flex-direction: column;
    align-items: stretch;
  }

  .action-btn {
    width: 100%;
    margin: 0 0 8px 0;
  }

  .action-btn:last-child {
    margin-bottom: 0;
  }
}
</style>
